import React from 'react';
import { Home, PenTool, HardHat } from 'lucide-react';
export function Audiences() {
  const audiences = [{
    title: 'Homeowners',
    copy: 'Get help choosing the right glass, hardware and enclosure style for your bathroom and budget.',
    icon: Home
  }, {
    title: 'Bathroom Remodelers & Designers',
    copy: 'Coordinate shower glass options, final measurements and installation details for a polished finished bathroom.',
    icon: PenTool
  }, {
    title: 'Builders & Contractors',
    copy: "Bring Kosin's Glass into the process for custom shower glass on new homes, remodels, additions and renovation projects.",
    icon: HardHat
  }];
  return <section className="py-20 bg-navy text-white" data-id="element-1348" data-mp="zidryk2fu16y">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1349" data-mp="zg18g2h17irs">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1350" data-mp="2wbgx0l7qkkb2">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 tracking-normal" data-id="element-1351" data-mp="318yy5pfihv8i">
            For Homeowners, Bathroom Remodelers, Designers & Builders
          </h2>
          <p className="text-lg text-blue-100" data-id="element-1352" data-mp="kw2pomwabnw8">
            Kosin's Glass works with homeowners planning bathroom upgrades as
            well as remodelers, designers, builders and contractors who need
            custom shower glass measured, fabricated and installed correctly.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-1353" data-mp="710dxj4rb4bi">
          {audiences.map((aud, i) => <div key={i} className="bg-navy-800 p-8 rounded-lg border border-navy-700 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1354" data-mp="zriof57t87yy" data-mpi={i}>
              <aud.icon className="w-10 h-10 text-primary mb-6" data-id="element-1355" data-mp="pu48d6pstl76" />
              <h3 className="text-xl font-bold mb-3" data-id="element-1356" data-mp="3fin0pc5sgy01">{aud.title}</h3>
              <p className="text-blue-100 leading-relaxed" data-id="element-1357" data-mp="3fjy43avbo3qm">{aud.copy}</p>
            </div>)}
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1358" data-mp="3almv12cupx9g">
          <a href="#quote" className="inline-flex items-center justify-center bg-primary hover:bg-primary-hover text-white font-semibold py-4 px-8 rounded-lg transition-colors" data-id="element-1359" data-mp="3c1sa630ybz29">
            Talk to a Shower Glass Specialist
          </a>
        </div>
      </div>
    </section>;
}